module.exports = __webpack_public_path__ + "static/media/galdisa_productos_fondo.309d330b.png";